module.exports = __webpack_public_path__ + "static/media/thumbnail.5dcb3892.jpg";